<template>
	<b-modal v-model="modal" @hidden="hideHandler" @ok="sendHandler" size="lg" cancel-title="Отмена" ok-title="Создать" :title="'Создать платёж на основе платежа ID ' + paymentId">
		<div class="d-block">
			<product-select v-if="serverDataReady"
				:type="type"
				:product="productId"
				@changeProduct="setProductIdHandler"
			></product-select>
		</div>
	</b-modal>
</template>
<script>
import product from '@/api/modules/product/product'
import ProductSelect from '@/components/product/ProductSelect'
export default {
	components: {
		'product-select': ProductSelect
	},
	data () {
		return {
			serverDataReady: false,
			modal: false,
			type: null,
			form: {
				productId: null
			}
		}
	},
	props: {
		show: {
			type: Boolean,
			default: false,
			required: true
		},
		paymentId: {
			type: Number,
			default: 0,
			required: true
		},
		productId: {
			type: Number,
			default: 0,
			required: true
		}
	},
	created () {
		this.modal = this.show
		this.form.productId = this.productId
		this.getProduct()
	},
	methods: {
		getProduct () {
			product.getProductById(this.productId).then((result) => {
				product.getProductTypeParent(result.type_id).then((result) => {
					this.type = result[0].id
					this.serverDataReady = true
				})
			})
		},
		hideHandler () {
			this.$emit('hide')
		},
		sendHandler () {
			this.$emit('send', this.form.productId)
		},
		setProductIdHandler (id) {
			this.form.productId = id
		}
	},
	watch: {
		show: function (val) {
			this.modal = val
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/payment/update/relation.vue